/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MediaList_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type GpxMediaList_offer$ref: FragmentReference;
declare export opaque type GpxMediaList_offer$fragmentType: GpxMediaList_offer$ref;
export type GpxMediaList_offer = {|
  +$fragmentRefs: MediaList_offer$ref,
  +$refType: GpxMediaList_offer$ref,
|};
export type GpxMediaList_offer$data = GpxMediaList_offer;
export type GpxMediaList_offer$key = {
  +$data?: GpxMediaList_offer$data,
  +$fragmentRefs: GpxMediaList_offer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "GpxMediaList_offer",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "MediaList_offer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '74812a809fc4d0640191900b2248fc73';

module.exports = node;
